import vars from 'src/common/vars';

export default function assetUrl(path) {
  return `${vars.get('ASSET_LOC')}${path}`;
}
